/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Campaigns_Mag7_SummaryInputs */

const en_campaigns_mag7_summary = /** @type {(inputs: Campaigns_Mag7_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invest in some of the world’s largest tech companies, Apple, Microsoft, NVIDIA, Amazon, Google, Meta, and Tesla, together on Glider, and earn 10% APR on your balance while you hold.`)
};

const de_campaigns_mag7_summary = /** @type {(inputs: Campaigns_Mag7_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Investieren Sie auf Glider gemeinsam in einige der größten Technologieunternehmen der Welt – Apple, Microsoft, NVIDIA, Amazon, Google, Meta und Tesla – und verdienen Sie 10 % APR auf Ihr Guthaben, solange Sie investiert bleiben.`)
};

const pt_br2_campaigns_mag7_summary = /** @type {(inputs: Campaigns_Mag7_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invista pela Glider, de uma só vez, em algumas das maiores empresas de tecnologia do mundo — Apple, Microsoft, NVIDIA, Amazon, Google, Meta e Tesla — e ganhe 10% de APR sobre seu saldo enquanto mantiver o investimento.`)
};

const tr_campaigns_mag7_summary = /** @type {(inputs: Campaigns_Mag7_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dünyanın en büyük teknoloji şirketlerinden Apple, Microsoft, NVIDIA, Amazon, Google, Meta ve Tesla’ya Glider üzerinden birlikte yatırım yapın ve yatırımınızı koruduğunuz sürece bakiyeniz üzerinden %10 APR kazanın.`)
};

const zh_cn2_campaigns_mag7_summary = /** @type {(inputs: Campaigns_Mag7_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在 Glider 上一键投资全球顶尖科技公司——苹果、微软、英伟达、亚马逊、谷歌、Meta 和特斯拉，持有期间还可按余额赚取 10% 年化收益。`)
};

const zh_hk2_campaigns_mag7_summary = /** @type {(inputs: Campaigns_Mag7_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在 Glider 一次過投資全球最大型的科技公司，包括 Apple、Microsoft、NVIDIA、Amazon、Google、Meta 及 Tesla，持有期間更可就結餘賺取 10% 年利率。`)
};

const ko_kr2_campaigns_mag7_summary = /** @type {(inputs: Campaigns_Mag7_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apple, Microsoft, NVIDIA, Amazon, Google, Meta, Tesla 등 세계 최대 테크 기업에 Glider에서 한 번에 투자하고, 보유하는 동안 잔액에 대해 연 10% APR을 받으세요.`)
};

const ru_ru2_campaigns_mag7_summary = /** @type {(inputs: Campaigns_Mag7_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Инвестируйте в крупнейшие технологические компании мира — Apple, Microsoft, NVIDIA, Amazon, Google, Meta и Tesla — вместе на Glider и получайте 10% годовых на баланс, пока держите позицию.`)
};

const es_419_campaigns_mag7_summary = /** @type {(inputs: Campaigns_Mag7_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invierte en algunas de las empresas tecnológicas más grandes del mundo —Apple, Microsoft, NVIDIA, Amazon, Google, Meta y Tesla— juntas en Glider, y gana 10% APR sobre tu saldo mientras las mantienes.`)
};

/**
* | output |
* | --- |
* | "Invest in some of the world’s largest tech companies, Apple, Microsoft, NVIDIA, Amazon, Google, Meta, and Tesla, together on Glider, and earn 10% APR on your..." |
*
* @param {Campaigns_Mag7_SummaryInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const campaigns_mag7_summary = /** @type {((inputs?: Campaigns_Mag7_SummaryInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Campaigns_Mag7_SummaryInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_campaigns_mag7_summary(inputs)
	if (locale === "de") return de_campaigns_mag7_summary(inputs)
	if (locale === "pt-BR") return pt_br2_campaigns_mag7_summary(inputs)
	if (locale === "tr") return tr_campaigns_mag7_summary(inputs)
	if (locale === "zh-CN") return zh_cn2_campaigns_mag7_summary(inputs)
	if (locale === "zh-HK") return zh_hk2_campaigns_mag7_summary(inputs)
	if (locale === "ko-KR") return ko_kr2_campaigns_mag7_summary(inputs)
	if (locale === "ru-RU") return ru_ru2_campaigns_mag7_summary(inputs)
	return es_419_campaigns_mag7_summary(inputs)
});